import React, { MutableRefObject } from "react";

import { formatNumericCurrency } from "utils";

import { CurrencyCode } from "consts";

import { Card } from "components";

export type WalletCardProps = {
  selected: boolean;
  headline: string;
  payout: number;
  currency: CurrencyCode;
  caption?: string;
  variant?: string;
  className?: string;
  onClick?: () => void;
  customRef?: MutableRefObject<HTMLDivElement>;
  dataTestId?: string;
};

export const WalletCard = ({ selected, headline, payout, currency, caption, variant, className, onClick, customRef, dataTestId }: WalletCardProps) => (
  <Card
    dataTestId={dataTestId}
    customRef={customRef}
    className={`wallet-card ${variant !== "vesting" && payout >= 0 ? "highlighted" : ""} ${!selected ? "unselected" : ""} ${className}`}
    onClick={onClick}
  >
    <span>{headline}</span>
    <span className="payout">{formatNumericCurrency(payout, { currency })}</span>
    <span className="paragraph-xs">{caption}</span>
  </Card>
);
